import { Inserter, Wrapper, DragAndDropContext, SessionRole, SftpDropArea, SecretsUnlock } from "nystem-components";
import ConnectionCssclass from "./connection/cssclass";
import "./index.css";
import "../../sftp/component/sftp/browser.css";
import "../../git/component/git.css";

const Index = () => (
  <ConnectionCssclass model={{ className: "nystem-remote h-full flow-root", offlineClass: "[filter:grayscale(1)]" }}>
    <DragAndDropContext>
      <SftpDropArea className="h-full text-xs" dropId="local">
        <DragAndDropContext>
          <Inserter match="*" source="/settings/hostname/host" />
          <SessionRole userrole="logged-out">
            <Inserter className="p-10" source="/adminUser/login" match="*" />
          </SessionRole>
          <SessionRole userrole="logged-in" className="text-sm">
            <Wrapper className="flex mt-14 overflow-y-scroll h-full-minus">
              <Inserter match="/server*" source="/server/menu" />
              <Inserter match="/site*" source="/site/menu" />
              <Inserter match="*index.html" source="/site/menu" />
              <Inserter match="/command*" source="/command/menu" />
              <Inserter match="/sync*" source="/sync/menu" />
              <Inserter match="/routine*" source="/routine/menu" />
              <Wrapper className="flex-1 min-w-0 max-w-full pb-8 pr-6">
                <Inserter match="/adminUser/security" className="p-6" />
                <Inserter match="*" exclude="/adminUser/security">
                  <SecretsUnlock>
                    <Inserter match="/site/*" />
                    <Inserter match="/server/*" />
                    <Inserter match="/command/*" />
                    <Inserter match="/sync/*" />
                    <Inserter match="/routine/*" />
                  </SecretsUnlock>
                </Inserter>
              </Wrapper>
            </Wrapper>
          </SessionRole>
        </DragAndDropContext>
      </SftpDropArea>
    </DragAndDropContext>
  </ConnectionCssclass>
);
export default Index;
